import React from 'react';
import styled from 'styled-components';
import transformationImg from '../assets/images/transformation.png';

const PageContainer = styled.div`
  padding-top: 80px;
  max-width: 900px;
  margin: 0 auto;
`;
const HeroImage = styled.div`
  width: 100%;
  height: 320px;
  background: url(${transformationImg}) center center/cover no-repeat;
  border-radius: 12px;
  margin-bottom: 2.5rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.07);
`;
const Title = styled.h1`
  font-size: 2.3rem;
  font-weight: 700;
  margin: 2rem 0 2.5rem 0;
  color: #222;
  text-align: center;
`;
const Section = styled.section`
  margin-bottom: 2.5rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 2rem 2.5rem;
`;
const SectionTitle = styled.h2`
  font-size: 1.4rem;
  color: var(--primary);
  margin-bottom: 1rem;
  font-weight: 600;
`;
const Paragraph = styled.p`
  color: #333;
  line-height: 1.7;
  margin-bottom: 1.2rem;
`;
const ServiceList = styled.ul`
  margin-top: 0.5rem;
  margin-bottom: 1.2rem;
  list-style: disc inside;
  padding-left: 1.2rem;
`;
const ServiceItem = styled.li`
  color: #333;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;
const TagList = styled.ul`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
  padding: 0;
  list-style: none;
`;
const Tag = styled.li`
  background: var(--primary);
  color: #fff;
  border-radius: 16px;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.4rem 1.1rem;
  margin-bottom: 0.5rem;
`;

const UseCaseAIFoodBeverage = () => (
  <PageContainer>
    <HeroImage />
    <Title>Automating Quality Control with AI in Food & Beverage</Title>
    <Section>
      <SectionTitle>The Situation</SectionTitle>
      <Paragraph>
        Food production companies often struggle with manual or visual-only quality control, leading to inconsistent product quality, high waste due to post-production defect detection, and lack of real-time tracking for root-cause analysis. Poor process visibility can reduce shelf stability, trigger recalls, and erode consumer trust.
      </Paragraph>
    </Section>
    <Section>
      <SectionTitle>How Platform0 Would Help</SectionTitle>
      <Paragraph>
        Platform0 would architect an AI-powered inspection and monitoring solution, using scalable digital infrastructure:
      </Paragraph>
      <ServiceList>
        <ServiceItem>Deploy computer vision models for real-time visual quality checks</ServiceItem>
        <ServiceItem>Use sensor-based anomaly detection across the production line</ServiceItem>
        <ServiceItem>Connect the QC system to a central data platform for traceability and analytics</ServiceItem>
        <ServiceItem>Architect the backend with scalable, event-driven microservices and cloud-native infrastructure</ServiceItem>
      </ServiceList>
    </Section>
    <Section>
      <SectionTitle>The Expected Outcomes</SectionTitle>
      <ServiceList>
        <ServiceItem>25–40% reduction in product waste</ServiceItem>
        <ServiceItem>Fewer recalls and improved brand confidence</ServiceItem>
        <ServiceItem>Real-time insights for process improvement</ServiceItem>
        <ServiceItem>Clearer compliance trails for audits and certifications (e.g., HACCP)</ServiceItem>
      </ServiceList>
    </Section>
    <Section>
      <SectionTitle>Relevant Platform0 Services</SectionTitle>
      <TagList>
        <Tag>AI Consultancy</Tag>
        <Tag>Cloud Solutions</Tag>
        <Tag>Digital Transformation</Tag>
      </TagList>
    </Section>
  </PageContainer>
);

export default UseCaseAIFoodBeverage;
